export default __webpack_public_path__ + "static/media/PalREAD_watermark.7bac33b0.png";